import { render } from "./MemoPositionLayout.vue?vue&type=template&id=0c2c5c5c"
import script from "./MemoPositionLayout.vue?vue&type=script&lang=js"
export * from "./MemoPositionLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__